import Select2 from './select2/Select2.vue';

export default {
  Select2
}
